import http from './http';

export const postsAPI = {
  // 피드 조회
  getFeed: async (page = 0, size = 20) => {
    const response = await http.get('/api/posts/feed', {
      params: { page, size },
    });
    return response.data;
  },

  // 탐색 조회
  getExplore: async (page = 0, size = 30) => {
    const response = await http.get('/api/posts/explore', {
      params: { page, size },
    });
    return response.data;
  },

  // 게시물 상세 조회
  getPost: async (postId) => {
    const response = await http.get(`/api/posts/${postId}`);
    return response.data;
  },

  // 게시물 수정 (캡션, 해시태그)
  updatePost: async (postId, data) => {
    const response = await http.put(`/api/posts/${postId}`, data);
    return response.data;
  },

  // 게시물 삭제 (소프트 삭제)
  deletePost: async (postId) => {
    await http.delete(`/api/posts/${postId}`);
  },

  // 휴지통 조회 (관리자 전용)
  getTrash: async (page = 0, size = 20) => {
    const response = await http.get('/api/posts/trash', {
      params: { page, size },
    });
    return response.data;
  },

  // 게시물 복구 (관리자 전용)
  restorePost: async (postId) => {
    const response = await http.post(`/api/posts/${postId}/restore`);
    return response.data;
  },

  // 게시물 영구 삭제 (관리자 전용)
  permanentDeletePost: async (postId) => {
    await http.delete(`/api/posts/${postId}/permanent`);
  },

  // 해시태그 검색
  searchByHashtag: async (hashtag, page = 0, size = 20) => {
    const response = await http.get('/api/posts/search', {
      params: { hashtag, page, size },
    });
    return response.data;
  },

  // 인기 해시태그 조회
  getPopularHashtags: async (limit = 10) => {
    const response = await http.get('/api/hashtags/popular', {
      params: { limit },
    });
    return response.data;
  },
};

